import { showMessage, loadingEnd, loadingStart, showPopup, closePopup } from "./uiActions";

export function getQPDataSource(id, documentTypeId, popupToShow, popUpInfo, hidden = false, presId = null) {
    return function (dispatch) {
        if (!hidden) {
            dispatch(showPopup("loadingPopup", "Loading Quick Picks..."))
        }
        fetch(`${process.env.REACT_APP_BACK_URL}/databases/${id}/${documentTypeId}/quickpicksource?presentationId=${presId}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()

            } else {
                return resp.json()
            }
        })
            .then((json) => {
                dispatch(setDatabase(json.connInfo))
                dispatch(setQPDataSource(json.qpSource))
                return ((hidden) ? dispatch(closePopup()) : dispatch(showPopup(popupToShow, popUpInfo)))
            }).catch((ex) => {
                return (hidden) ? null : dispatch(showPopup("confirmationPopup", "Get Quick Pick Data Source Failed", false))
            })
    }
}

export function getPresentationDataSource(id, documentTypeId, popupToShow, popUpInfo, hidden = false) {
    return function (dispatch) {
        if (!hidden) {
            dispatch(showPopup("loadingPopup", "Loading Presentation Data..."))
        }
        fetch(`${process.env.REACT_APP_BACK_URL}/databases/${id}/${documentTypeId}/presentationsource`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error();
            } else {
                return resp.json();
            }
        }).then((json) => {
            dispatch(setDatabase(json.connInfo))
            return ((hidden) ? dispatch(closePopup()) : dispatch(showPopup(popupToShow, popUpInfo)))
        }).catch((ex) => {
            return (hidden) ? null : dispatch(showPopup("confirmationPopup", "Get Chart Data Source Failed", false))
        });
    }
}

export function getDataSource(databaseID, dataSourceID) {
    return function (dispatch) {
        dispatch(loadingStart())
        fetch(`${process.env.REACT_APP_BACK_URL}/databases/${databaseID}/${dataSourceID}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        })
            .then((json) => {
                dispatch(loadingEnd())
                dispatch(setDatabase(json.connInfo))
                return dispatch(setDataSource(json.dataSource))
            }).catch((ex) => {
                dispatch(loadingEnd())
                return dispatch(showMessage("Get Global Data Source Failed", false))
            })
    }
}

export async function callApiPost(url, postObject) {
    let dataGrab = await fetch(url, {
        method: 'POST',
        headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
        },
        body: JSON.stringify(postObject)
    });
    let response = await dataGrab.json();
    return response;
};

export async function getConnectionMembers(connectionId, allConnectionIds, alias, dimensionName, searchTerm, data, connectionName) {
    let url = `${process.env.REACT_APP_BACK_URL}/databases/getconnectionmembers`;
    let response = await callApiPost(url, {
        Id: parseInt(connectionId),
        AllConnectionIds: allConnectionIds,
        DatabaseAlias: alias,
        DimensionAlias: dimensionName,
        ConnectionName: connectionName,
        Segment: null,
        SearchTerm: searchTerm,
        CurrentlyLoadedItems: data
    });
    return response;
}

export async function getConnectionSegments(connectionId, allConnectionIds, alias, dimensionName, connectionName) {
    let url = `${process.env.REACT_APP_BACK_URL}/databases/getconnectionsegments`;
    let response = await callApiPost(url, {
        Id: parseInt(connectionId),
        AllConnectionIds: allConnectionIds,
        DatabaseAlias: alias,
        DimensionAlias: dimensionName,
        ConnectionName: connectionName
    });
    return response;
}

export function getConnectionSegmentsPromise(connectionId, allConnectionIds, alias, dimensionName, connectionName) {
    let url = `${process.env.REACT_APP_BACK_URL}/databases/getconnectionsegments`;
    
    return new Promise(function (resolve, reject) {
        fetch(url, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                Id: parseInt(connectionId),
                AllConnectionIds: allConnectionIds,
                DatabaseAlias: alias,
                DimensionAlias: dimensionName,
                ConnectionName: connectionName
            })
        })
            .then((resp) => {
                if (resp.status !== 200) {
                    throw new Error()
                } else {
                    return resp.json()
                }
            })
            .then((json) => {
                resolve(json);
            })
            .catch((ex) => {
                reject(ex)
            });
    });
}

export async function getSegmentMembers(connectionId, allConnectionIds, alias, dimensionName, segmentParent, multiSegmentAlias, multiSegmentMembers, connectionName) {
    let url = `${process.env.REACT_APP_BACK_URL}/databases/getsegmentmembers`;
    let response = callApiPost(url, {
        Id: parseInt(connectionId),
        AllConnectionIds: allConnectionIds,
        DatabaseAlias: alias,
        DimensionAlias: dimensionName,
        ConnectionName: connectionName,
        Segment: segmentParent,
        SearchTerm: "",
        CurrentlyLoadedItems: [],
        MultiSegmentAlias: multiSegmentAlias,
        MultiSegmentMembers: multiSegmentMembers
    });
    return response;
}

export async function getMembersWithinSegment(connectionId, allConnectionIds, alias, dimensionName, segmentParent, segmentChild, multiSegmentAlias, multiSegmentMembers, connectionName) {
    let url = `${process.env.REACT_APP_BACK_URL}/databases/getmemberswithinsegment`;
    let response = callApiPost(url, {
        Id: parseInt(connectionId),
        AllConnectionIds: allConnectionIds,
        DatabaseAlias: alias,
        DimensionAlias: dimensionName,
        ConnectionName: connectionName,
        ParentSegment: segmentParent,
        ChildSegment: segmentChild,
        MultiSegmentAlias: multiSegmentAlias,
        MultiSegmentMembers: multiSegmentMembers
    });
    return response;
}

export function setQPDataSource(qp) {
    return { 'type': 'SET_QUICKPICK_DATA_SOURCE', qp}
}

export function setDataSource(payload) {
    return { 'type': 'SET_DATA_SOURCE', payload }
}

export function setDatabase(connInfo) {
    return { 'type': 'SET_DATABASE', connInfo }
}

export function setDatabases(payload) {
    return { type: 'SET_DATABASES', payload }
}

export function flipDBSwitch() {
    return { type: 'FLIP_DATABASES_SWITCH' }
}

export function setPresentationSource(presSource) {
    return { 'type': 'SET_PRESENTATION_SOURCE', presSource }
}

export function flipSingleDBSwitch() {
    return { type: 'FLIP_SINGLE_DATABASE_SWITCH' }
}